import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const ProductReceived = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);
	const tab = new URLSearchParams(window.location.search).get('tab')

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, productReceived: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false)
	}

	const steps = [
		{
			target: '.productReceivedFirstStep',
			title: "View Order",
			content: 'Click to view order details.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.productReceivedSecondStep',
			title: "Update Order",
			content: 'Click to update the status of this order.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.productReceivedThirdStep',
			title: "Move to Preparing",
			content: 'Put the ordering in preparing status.',
			disableBeacon: true,
			placement: "top",
			modalTriggers: 'productSalesModal'
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.productReceivedFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 200);
		return () => clearInterval(interval);
	}, [tab, walkthrough.data.productReceived]);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.productReceived)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="productReceived" 
			featureName="sales"
		/>
	);
}
